import type { FormSchemaResolved } from '#layers/block-engine/public';
import type { FieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import type { GlobalCollectionId } from '#layers/data-model/types/schema/ids';
import type { PrimitiveType } from '#layers/data-model/types/schema/primitive-type';
import { getFormSchemaFieldNames, resolveFormSchema } from '#layers/block-engine/public';

interface FieldTypeOptionNameContext<TOptions extends Record<string, any>> {
	fieldType: FieldTypeTemplate<TOptions>;
	primitiveType: PrimitiveType;
	typeOptions?: TOptions | null;
	collectionId: GlobalCollectionId;
	isNewField?: boolean;
}

export function getFieldTypeOptionNames<TOptions extends Record<string, any>>({
	fieldType,
	primitiveType,
	typeOptions,
	collectionId,
	isNewField = false,
}: FieldTypeOptionNameContext<TOptions>): string[] {
	if (fieldType.type !== 'primitive' || !fieldType.options) {
		return [];
	}

	const schema = resolveFormSchema({
		schema: fieldType.options,
		values: typeOptions ?? {} as TOptions,
		context: {
			primitiveType,
			isNewField,
			collectionId,
		},
	}) as FormSchemaResolved;

	return getFormSchemaFieldNames(schema);
}
